import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createResourceId, parseResourceId } from ".";
import { mapObjectMapValues } from "../../utils";
import { createResourceVariantValidator } from "../resources/SWBaseResourceVariant";
/** @public */ /** @internal */ export const rootResourceVariantVersions = {};
/** @internal */ export const rootResourceVariantMigrations = defineMigrations({});
/** @public */ export function isResourceVariant(record) {
    if (!record) return false;
    return record.typeName === "resource_variant";
}
/** @public */ export function isResourceVariantId(id) {
    if (!id) return false;
    return id.startsWith("resource_variant:");
}
export const parseResourceVariantId = (id)=>{
    if (!id) return undefined;
    if (!id.startsWith("resource_variant:")) return undefined;
    const parts = id.replace("resource_variant:", "").split(":");
    const variant = parts.pop();
    if (!variant) return undefined;
    const parsedResourceId = parseResourceId("resource:" + parts.join(":"));
    if (!parseResourceId) return undefined;
    return {
        ...parsedResourceId,
        variant
    };
};
// /** @public */
// export function createResourceVariantId(id?: string): SWResourceVariantId {
//   return `resource_variant:${id ?? nanoid()}` as SWResourceVariantId
// }
export const createResourceVariantIdPrefix = (type)=>`resource_variant:${type}:`;
// 'resource_variant:<type>:<name>:<org-id>:global|organization:0'
export function createResourceVariantId({ type, name, organizationId, scope, variant }) {
    const resourceId = createResourceId({
        type,
        name,
        organizationId,
        scope
    });
    return `resource_variant:${resourceId.replace("resource:", "")}:${variant}`;
}
/** @internal */ export function createResourceVariantRecordType(resource_variants) {
    return createRecordType("resource_variant", {
        migrations: undefined,
        // defineMigrations({
        // currentVersion: rootResourceVariantMigrations.currentVersion,
        // firstVersion: rootResourceVariantMigrations.firstVersion,
        // migrators: rootResourceVariantMigrations.migrators,
        // subTypeKey: "type",
        // subTypeMigrations: mapObjectMapValues(
        //   resource_variants,
        //   (_, v) => v.migrations ?? defineMigrations({})
        // ),
        // }),
        scope: "session",
        validator: T.model("resource_variant", T.union("type", mapObjectMapValues(resource_variants, (type, { props, meta })=>createResourceVariantValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
